module.exports = __webpack_public_path__ + "img/PaCE_AgedCare_Logo_RGB.3351e251.svg";